import React from "react";
import { mergeKpiConfigs } from "../config";
import InfoTitle from "./InfoTitle";

const KpiDescription = ({ description, descriptionConfig, option }) => {
  ({ descriptionConfig } = mergeKpiConfigs(option, {
    descriptionConfig,
  }));

  return (
    <div>
      <InfoTitle title={description} {...descriptionConfig} />
    </div>
  );
};

export default KpiDescription;
